<template>
  <div>
    <div class="flex">
      <div class="inline-flex flex-initial px-4 border-t border-b border-l border-gray-medium bg-gray-hr rounded-l">
        <span class="self-center">http(s)://</span>
      </div>

      <div class="flex-grow">
        <input
          id="url"
          type="text"
          name="url"
          :placeholder="placeholder"
          :value="value"
          v-validate="{ required: required, url: { require_tld: true } }"
          @input="adjustUrl"
        />
      </div>

      <a class="inline-flex px-2 text-black underline text-black" :href="`https://${value}`" target="_blank">
        <span class="self-center uppercase">Test Link</span>
      </a>
    </div>

    <span v-show="errors.has('url')" class="text-lg error text-error-red">
      {{ errors.first('url') }}
    </span>
  </div>
</template>

<script>
import urlFilter from "../../mixins/url-filter";

export default {
  name: "UrlInput",
  mixins: [urlFilter],
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    value: String
  },
  data() {
    return {
      url: ""
    };
  },
  methods: {
    adjustUrl(event) {
      const url = this.filterUrl(event.target.value);
      this.$emit("input", url);
    },
    focus() {
      this.$refs.url.focus();
    }
  }
};
</script>

<style scoped>
  #url {
    border-radius: 0;
  }
</style>
